import React from 'react';

export function TableFlipIcon({ width = 200, height, color = 'currentColor', className, style }) {
    const aspectRatio = 5.2;
    const computedHeight = height || Math.round(width / aspectRatio);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 520 100"
            width={width}
            height={computedHeight}
            className={className}
            style={style}
            role="img"
            aria-label="Table flip"
        >
            <text
                x="260"
                y="58"
                textAnchor="middle"
                dominantBaseline="central"
                fill={color}
                fontFamily="'Courier New', Courier, monospace"
                fontWeight="bold"
                fontSize="52"
                letterSpacing="-1"
            >
                {'(╯°□°）╯︵ ┻━┻'}
            </text>
        </svg>
    );
}
